module.exports = __webpack_public_path__ + "img/purple_vip.0025e54d.png";